import React from "react";
import styles from "./AddHiddenItemForm.module.scss";
import classnames from "classnames";

export default function SelectableProductDisplay({
  product,
  onSelect,
  "data-testid": dataTestId,
}) {
  return (
    <div
      className={classnames(
        styles.selectableItem,
        { [styles.selectable]: !!onSelect },
        "flex-row flex-center spaced-content-lg",
      )}
      onClick={onSelect}
      data-testid={dataTestId}
    >
      <img className={styles.productImage} src={product.thumbnailUrl} />

      <div className="flex-1">
        <div className="text-sm font-weight-bold">{product.itemName}</div>
        <div className={classnames("text-xs", styles.productDescription)}>
          {product.description}
        </div>
        <div className="text-xs">Qty: {product.packageQuantity}</div>
      </div>
    </div>
  );
}
